document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('#MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const button = form.querySelector('[data-add-button]');
    const price = document.querySelector('[data-product-price]');
    const conditionBadge = document.querySelector('[data-condition-badge] .condition-badge');
    if (!select || !button) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      button.disabled = option.dataset.available !== 'true';
      button.querySelector('span').textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (conditionBadge && option.dataset.condition) conditionBadge.textContent = option.dataset.condition;
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.dataset.galleryThumb);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });

  const params = new URLSearchParams(window.location.search);
  const fieldValue = (key) => (params.get(key) || '').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 200);
  const wantedField = document.querySelector('[data-wanted-product]');
  if (wantedField) {
    const wanted = fieldValue('wanted');
    if (wanted) {
      wantedField.value = wanted;
      const trade = document.getElementById('IntentTrade');
      if (trade) trade.checked = true;
    }
  }
  const sellingField = document.querySelector('[data-selling-product]');
  if (sellingField && fieldValue('selling')) {
    sellingField.value = fieldValue('selling');
    [['Brand', 'brand'], ['Model', 'model'], ['Year', 'year']].forEach(([id, key]) => {
      const input = document.getElementById(id);
      if (input && !input.value) input.value = fieldValue(key);
    });
  }
  const context = document.querySelector('[data-product-context]');
  if (context && (fieldValue('selling') || fieldValue('wanted'))) {
    const selling = fieldValue('selling');
    const label = selling ? context.dataset.sellingLabel : context.dataset.wantedLabel;
    context.textContent = `${label} ${selling || fieldValue('wanted')}.${selling ? ` ${context.dataset.checkLabel}` : ''}`;
    context.hidden = false;
  }
});
